"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ExternalSortOptions = void 0;
var ExternalSortOptions;
(function (ExternalSortOptions) {
    ExternalSortOptions["Popularity"] = "popularity";
    ExternalSortOptions["Price"] = "price";
    ExternalSortOptions["Title"] = "title";
    ExternalSortOptions["Distance"] = "distance";
    ExternalSortOptions["Score"] = "score,";
})(ExternalSortOptions || (exports.ExternalSortOptions = ExternalSortOptions = {}));
//# sourceMappingURL=types.js.map